import React, {useCallback, useEffect, useRef, useState} from 'react'
import ModalWindow from "../../../UI/ModalWindow";
import {useDispatch, useSelector} from "react-redux";
import {
    createBrands,
    removePageFromUser,
    requestBrands,
    updateBrands,
    createBrandFaq,
    updateBrandFaq,
    deleteBrandFaq
} from "../../../../actions/requests";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {defaultNeedsPrompt, defaultSystemInstruction, getIcon, SanitizeHTML} from "../../../../constants";
import PagesSelectionItem from "../../../UI/PagesSelectionItem";
import Button from "../../../UI/Button";
import {addPage, initCurrentPages, removePage, setSelectedBrand} from "../../../../actions/brands";
import BrandsPage from "./BrandsPage";
import {setShowBrandsModal} from "../../../../actions/ui";
import {faArrowLeft, faChevronDown, faXmarkLarge} from "@awesome.me/kit-a13c95776b/icons/modules/sharp/thin";
import SwitchItem from "../../../UI/SwitchItem";
import {Multiselect} from "multiselect-react-dropdown";
import TestBrand from "./TestBrand";
import {useAbility} from "@casl/react";
import {AbilityContext} from "../../../../utils/app";
import './faqs.scss';
import {faPenToSquare, faTrashCan} from "@fortawesome/free-regular-svg-icons";
import BrandsFaqModal from "./BransFaqModal";
import TagInput from "../../../UI/TagInput";

const BrandsModal = (props) => {
    const ability = useAbility(AbilityContext)
    const showBrandsModal = useSelector(state => state.ui.showBrandsModal)
    const brand = useSelector(state => state.brands.selectedBrand)
    const {name, info, enabled, system_instruction, ai_trigger, exclude_ai_trigger, exclude_trigger_list,  delay, delay_type, delay_min, mention, tone, tone_style,
        auto_reply, auto_draft, auto_archive, needs_reply_prompt, moderation_limit, moderation_limit_option, reply_faqs} = brand.attributes || {system_instruction: defaultSystemInstruction, needs_reply_prompt: defaultNeedsPrompt}
    const [enableTone, setEnableTone] = useState(tone || false)
    const [autoArchive, setAutoArchive] = useState(auto_archive || false)
    const [enableMention, setEnableMention] = useState(mention || false)
    const [enableDelay, setEnableDelay] = useState(delay)
    const [showDelayTime, setShowDelayTime] = useState(delay_type == "fixed")
    const [aiTrigger, setAiTrigger] = useState(ai_trigger || "needs_reply")
    const [excludeAiTrigger, setExcludeAiTrigger] = useState(exclude_ai_trigger || [])
    const [autoReply, setAutoReply] = useState(auto_reply || false)
    const [autoDraft, setAutoDraft] = useState(auto_draft || false)
    const dispatch = useDispatch()
    const brandForm = useRef()
    const faqForm = useRef()
    const btnRef = useRef()
    const defaultExcludeAiTrigger = [{name: 'Comments contains just a mention', id: "just_mention"},
                                     {name: 'Comments contains just an emoji', id: "just_emoji"},
                                     {name: 'Threaded comments (just top-level)', id: 'threaded'},
                                     {name: 'Comments contains specific keywords', id: 'keywords'}]
    const [moderationLimit, setModerationLimit] = useState(moderation_limit)
    const [moderationLimitOption, setModerationLimitOption] = useState(moderation_limit_option || "ads_and_posts")
    const [showFaqModal, setShowFaqModal] = useState(false)
    const [editingFaq, setEditingFaq] = useState(null)
    const [faqs, setFaqs] = useState(reply_faqs || [])

    useEffect(() => {
        if (autoReply) setAutoDraft(false)
    }, [autoReply])

    useEffect(() => {
        if (autoDraft) setAutoReply(false)
    }, [autoDraft])

    const changeModerationlimit = (e) => {
        setModerationLimit(e.target.checked)
    }

    const changeModerationlimitOption = (e) => {
        setModerationLimitOption(e.target.value)
    }

    const handleAutoReply = (e) => {
        setAutoReply(e.currentTarget.checked)
    }

    const handleAutoDraft = (e) => {
        setAutoDraft(e.currentTarget.checked)
    }

    const handleAiTrigger = (e) => {
        setAiTrigger(e.currentTarget.value)
    }

    const addExcludeAiTrigger = (selectedList, selectedItem) => {
        setExcludeAiTrigger([...excludeAiTrigger, selectedItem.id])
    }

    const removeExcludeAiTrigger = (selectedList, selectedItem) => {
        setExcludeAiTrigger(excludeAiTrigger.filter(t => t !== selectedItem.id))
    }

    const changeTone = (e) => {
        setEnableTone(e.currentTarget.checked)
    }

    const changeMention = (e) => {
        setEnableMention(e.currentTarget.checked)
    }

    const changeAutoArchive = (e) => {
        setAutoArchive(e.currentTarget.checked)
    }

    const changeDelay = (e) => {
        setEnableDelay(e.currentTarget.checked)
    }

    const delayTypeHandler = (e) => {
        if(e.target.value == "fixed")
        {
            setShowDelayTime(true)
        }else{
            setShowDelayTime(false)
        }
    }

    const handleClose = () => {
        dispatch(setSelectedBrand())
        dispatch(setShowBrandsModal())
    }

    useEffect(()=>{
        if (showBrandsModal) {
            dispatch(requestBrands(true))
        }
    },[showBrandsModal])

    const handleBrandForm = (e) => {
        e.preventDefault()
        const formData = new FormData(brandForm.current)

        if(brand.attributes){
            dispatch(updateBrands(brand.id, formData))
        }else{
            // Append faqs to formData for new brand
            faqs.forEach((faq, i) => {
                formData.append(`brand[reply_faqs][${i}][question]`, faq.attributes.question)
                formData.append(`brand[reply_faqs][${i}][answer]`, faq.attributes.answer)
            })
            dispatch(createBrands(formData))
        }
        handleClose()
    }

    const isValidForm = useCallback(e => {
    }, [])


    const openCreateFaq = () => {
      setEditingFaq(null)
      setShowFaqModal(true)
    }

    const openEditFaq = (faqOrIndex) => {
        setEditingFaq(faqOrIndex)
        setShowFaqModal(true)

    }

    const deleteFaq = (faqOrIndex) => {
        if (brand.attributes) {
            dispatch(deleteBrandFaq(faqOrIndex.id));
            setFaqs(prev => prev.filter(faq => faq.id !== faqOrIndex.id));
        } else {
            setFaqs(prev => prev.filter((_, idx) => idx !== faqOrIndex));
        }
    }

    const handleFaqFormSubmit = (e) => {
      e.preventDefault()
      const formData = new FormData(faqForm.current)

      if(brand.attributes){
          if (editingFaq) {
              dispatch(updateBrandFaq(editingFaq.id, formData, setFaqs))
          } else {
              dispatch(createBrandFaq(formData, null, setFaqs))
          }
      }else{
        const question = formData.get('reply_faq[question]')
        const answer = formData.get('reply_faq[answer]')

        if (typeof editingFaq === 'number') {
          setFaqs(prev => prev.map((faq, idx) => idx === editingFaq ? { attributes: { question, answer } } : faq))
        } else {
          setFaqs(prev => [...prev, { attributes: { question, answer } }])
        }
      }

      setShowFaqModal(false)
      setEditingFaq(null)
    }

    // Compute question and answer for BrandsFaqModal
    let modalQuestion = ''
    let modalAnswer = ''
    if (showFaqModal) {
      if (brand.attributes) {
        modalQuestion = editingFaq?.attributes?.question || ''
        modalAnswer = editingFaq?.attributes?.answer || ''
      } else if (typeof editingFaq === 'number' && faqs[editingFaq]) {
        modalQuestion = faqs[editingFaq]?.attributes?.question || ''
        modalAnswer = faqs[editingFaq]?.attributes?.answer || ''
      }
    }

    return (
        <>
            {showBrandsModal && <div className="agents">
                <button type="reset" className="btn btn-tr-bl mb-4 pl-0" onClick={() => handleClose()}>
                    <FontAwesomeIcon icon={faArrowLeft} className="mr-2"/>
                    Go back
                </button>

                {/*<h4 className="mb-4">{brand ? 'Edit' : 'Add new'} agent</h4>*/}

                <form onSubmit={handleBrandForm} ref={brandForm}>
                    <input type="hidden" name="brand[enabled]" value={enabled}/>
                    {excludeAiTrigger.map((item, index) => (
                        <input key={index} type="hidden" name="brand[exclude_ai_trigger][]" value={item} />
                    ))}
                    {excludeAiTrigger.length==0 && <input type="hidden" name="brand[exclude_ai_trigger][]" value="" />}
                    {!autoReply && <input type="hidden" name="brand[auto_reply]" value="false"/>}
                    {!autoDraft && <input type="hidden" name="brand[auto_draft]" value="false"/>}
                    {!autoArchive && <input type="hidden" name="brand[auto_archive]" value="false"/>}
                    {!enableMention && <input type="hidden" name="brand[mention]" value="false"/>}
                    {!enableTone && <input type="hidden" name="brand[tone]" value="false"/>}
                    {!enableDelay && <input type="hidden" name="brand[delay]" value="false"/>}
                    {!moderationLimit && <input type="hidden" name="brand[moderation_limit]" value="false"/>}
                    <div className="main row">
                        <div className="form-group mb-3">
                            <label className="mb-8">Name</label>
                            <input type="text" name="brand[name]"
                                   defaultValue={name}
                                   className="form-control"
                                   // required="required"
                                   onChange={isValidForm}/>
                        </div>

                        <BrandsPage />

                        <div className="form-group mb-3">
                            <label className="mb-8">Instructions</label>
                            <textarea type="text" name="brand[system_instruction]"
                                      defaultValue={system_instruction}
                                      className="form-control"
                                      rows="8"
                                      maxLength="100000"
                                // required="required"
                                      onChange={isValidForm}/>
                        </div>

                        <div className="form-group mb-3">
                            <label className="mb-8">Knowledge</label>
                            <textarea type="text" name="brand[info][knowledge]"
                                   defaultValue={info && info.knowledge}
                                   className="form-control"
                                      rows="8"
                                      maxLength="100000"
                                      placeholder="Add information about your company, products or services"
                                   // required="required"
                                   onChange={isValidForm}/>
                            
                        </div>


                      <div>
                        <label className="fw-bold mb-8">FAQ</label>
                          {faqs?.length > 0 && (
                                <ul className="list-group faq-list" >
                                  {faqs.map((faq, index) => (
                                    <div key={index} className="faq-wr px-0">
                                      <div className="faq-row">
                                        <div className="form-control faq-input" data-bs-toggle="collapse" data-bs-target={`#collapse${index}`} aria-expanded="false" aria-controls={`collapse${index}`}>
                                            <SanitizeHTML html={faq?.attributes?.question.replaceAll('\n','<br>')} />
                                        </div>
                                        <div className="faq-btns">
                                            <Button type="button" clickHandler={() => openEditFaq(brand.attributes ? faq : index)}>
                                              <FontAwesomeIcon icon={faPenToSquare} />
                                            </Button>
                                            <Button type="button" clickHandler={() => deleteFaq(brand.attributes ? faq : index)}>
                                              <FontAwesomeIcon icon={faTrashCan} />
                                            </Button>
                                        </div>
                                      </div>
                                        <div className="collapse mt-2" id={`collapse${index}`}>
                                            <SanitizeHTML html={faq?.attributes?.answer.replaceAll('\n','<br>')} />
                                        </div>
                                    </div>
                                  ))}
                                </ul>
                          )}
                      </div>


                        <div className="form-group mb-3">
                            <Button className="btn btn-success mt-2" type="button" clickHandler={openCreateFaq}>Create FAQ</Button>
                        </div>

                        <div className="form-group mb-3">
                            <label>Intent detection</label>
                            <div className="nrt mb-8">
                                <span>The prompt that our AI uses to determine whether a comment is labeled as </span>
                                <div className='nr-b badge badge-light-green ml-1'>
                                    Needs reply
                                </div>
                            </div>

                            <input type="text" name="brand[needs_reply_prompt]"
                                   defaultValue={needs_reply_prompt}
                                   className="form-control"
                                   onChange={isValidForm}/>
                        </div>

                        {ability.can("test_comment","PagesController") && (
                            <div className="form-group mb-3">
                                <label>Playground</label>
                                <div className="nrt mb-8">
                                    <span>Enter a test comment to see what the AI response would be based on your instructions and knowledge.</span>
                                </div>
                                <TestBrand />
                            </div>
                        )}

                        <div className="form-group mb-3">
                            <label>Agent</label>
                            <SwitchItem title="AI auto-drafts"
                                        wrapperClass="form-group mt-2 mb-0"
                                        value={autoDraft}
                                        checked={autoDraft}
                                        changeHandler={handleAutoDraft}
                                        desc="When enabled, the AI agent will draft comment replies you can edit before sending."
                                        name="brand[auto_draft]">
                            </SwitchItem>
                            <SwitchItem title="AI auto-replies"
                                        wrapperClass="form-group mt-2 mb-0"
                                        value={autoReply}
                                        checked={autoReply}
                                        changeHandler={handleAutoReply}
                                        desc="When enabled, the AI agent will automatically send replies to your comments."
                                        name="brand[auto_reply]">
                            </SwitchItem>
                        </div>

                        {(autoReply || autoDraft) && <>
                            <div className="form-group mb-3">
                                <label className="mb-8">Reply to</label>
                                <select className="form-select" name="brand[ai_trigger]" defaultValue={aiTrigger}
                                        onChange={handleAiTrigger} required="required">
                                    <option value="needs_reply">Automated AI replies to visible comments that need a reply</option>
                                    <option value="visible">Automated AI replies to all visible comments</option>
                                    <option value="all">Automated AI replies to all comments (both hidden and visible)</option>
                                </select>
                            </div>

                            <div className="form-group mb-3">
                                <label className="mb-8">Do not reply to</label>
                                    <Multiselect
                                        customCloseIcon={<FontAwesomeIcon icon={faXmarkLarge} className="ml-2"/>}
                                        placeholder={"Select comments"}
                                        hidePlaceholder={excludeAiTrigger.length > 0}
                                        emptyRecordMsg="No other options available..."
                                        options={defaultExcludeAiTrigger}
                                        selectedValues={defaultExcludeAiTrigger.filter(t => excludeAiTrigger.includes(t.id))}
                                        onSelect={addExcludeAiTrigger}
                                        onRemove={removeExcludeAiTrigger}
                                        displayValue="name"
                                    />

                                {excludeAiTrigger.includes("keywords") &&
                                <div className="my-2">
                                    <label className="mb-8">Keywords</label>
                                    <TagInput name="brand[exclude_trigger_list]" tags={exclude_trigger_list || []}/>
                                </div>
                                }
                            </div>

                            {!autoDraft && <SwitchItem title="Auto-archive"
                                        value={autoArchive}
                                        checked={autoArchive}
                                        wrapperClass="form-group mb-3"
                                        name="brand[auto_archive]"
                                        desc="Archive after reply has been sent"
                                        changeHandler={changeAutoArchive}>
                            </SwitchItem>}

                            <SwitchItem title="Add mention"
                                          value={enableMention}
                                          checked={enableMention}
                                          wrapperClass="form-group mb-3"
                                          name="brand[mention]"
                                          desc="Mention the user who commented so he/she gets notified"
                                          changeHandler={changeMention}>
                            </SwitchItem>

                            <SwitchItem title="Tone of voice"
                                        value={enableTone}
                                        checked={enableTone}
                                        wrapperClass="form-group mb-3"
                                        name="brand[tone]"
                                        desc="Choose a tone of voice that matches your brand"
                                        changeHandler={changeTone}>
                                {enableTone && (<>
                                    <div className="mlm-2_5 mt-2 form-group mb-2">
                                        <select className="form-select" defaultValue={tone_style} name="brand[tone_style]">
                                            <option value="professional">Professional</option>
                                            <option value="funny">Funny</option>
                                            <option value="conversational">Conversational</option>
                                            <option value="casual">Casual</option>
                                            <option value="helpful">Helpful</option>
                                        </select>
                                    </div>
                                </>)}
                            </SwitchItem>

                            {!autoDraft && <SwitchItem title="Send with a delay"
                                        value={enableDelay}
                                        wrapperClass="form-group mb-3"
                                        checked={enableDelay}
                                        name="brand[delay]"
                                        desc="Send auto-replies with a random or fixed delay"
                                        changeHandler={changeDelay}>

                                {enableDelay && (<>
                                    <div className="mlm-2_5 mt-2 form-group mb-2">
                                        <select className="form-select" defaultValue={delay_type} name="brand[delay_type]"
                                                onChange={delayTypeHandler}>
                                            <option value="random">Random delay of up to 10 minutes</option>
                                            <option value="fixed">Set fixed time delay</option>
                                        </select>
                                    </div>
                                    {showDelayTime && <div className="mlm-2_5 col-lg-3 mb-2">
                                        <div className="input-group mb-3">
                                            <input type="number" name="brand[delay_min]" min={1} max={600} step={1}
                                                   defaultValue={delay_min || 1} className="form-control"  aria-describedby="basic-addon2"/>
                                            <span className="input-group-text" id="basic-addon2">minutes</span>
                                        </div>
                                    </div>}
                                </>)}
                            </SwitchItem>}

                            <SwitchItem
                                title="Apply agent to"
                                wrapperClass="form-group mb-3"
                                desc="Choose to apply the agent to posts only, ads only, or both."
                                value={moderationLimit}
                                checked={moderationLimit}
                                name="brand[moderation_limit]"
                                changeHandler={changeModerationlimit}
                            >
                                {moderationLimit && (<>
                                        <div className="mlm-2_5 mt-2 form-group mb-2">
                                            <select className="form-select" defaultValue={moderation_limit_option} name="brand[moderation_limit_option]"
                                                    onChange={changeModerationlimitOption}>
                                                <option value="ads_and_posts">Both posts and ads</option>
                                                <option value="ads_only">Ads only</option>
                                                <option value="posts_only">Posts only</option>
                                            </select>
                                        </div>
                                    </>
                                )}
                            </SwitchItem>
                        </>}

                    </div>

                    <div className="row mt-4">
                        <div>
                            <button type="submit" className="btn btn-primary float-end" ref={btnRef}>Save</button>
                            <button type="reset" className="btn btn-secondary float-end mx-2"
                                    onClick={() => handleClose()}>Cancel</button>
                        </div>
                    </div>
                </form>

                <BrandsFaqModal handleFaqFormSubmit={handleFaqFormSubmit} faqForm={faqForm} showFaqModal={showFaqModal}
                                setShowFaqModal={setShowFaqModal} editingFaq={editingFaq} question={modalQuestion} answer={modalAnswer}/>

            </div>}
        </>
    )
}

export default React.memo(BrandsModal)